import SideActionBase from '@/plugin/sideActions/sideActionBase';
import { Component } from 'vue-property-decorator';

@Component
export default class ContactActionComponent extends SideActionBase<any> {
    public createContact(e): void {
        this.finished(e);
    }
}
